import React, { useCallback, useEffect, useState } from "react";
import { AlertLineSuggestedNoteRef } from "../../models/alert-line-suggested-note/alert-line-suggested-note-ref";
import { AlertLineOrderedSuggestedNotesApiService } from "../../services/alert-line-suggested-note/alert-line-ordered-suggested-notes-api.service";
import { AlertLineOrderedSuggestedNotesFilter } from "../../models/alert-line-suggested-note/alert-line-ordered-suggested-note-filter";
import { Page } from "../../models/api/page";
import { Button, Chip, Dialog, DialogContent, Divider, Grid, IconButton, Typography, useTheme } from "@mui/material";
import DialogTitle from "../DialogTitle/DialogTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { AlertLineURLRef } from "../../models/alert-line-url/alert-line-url-ref";
import { AvailableLanguageRef } from "../../models/available-language";
interface Props {
  alertLineURL?: AlertLineURLRef | null;
  reportLanguage?: AvailableLanguageRef | null;
  handleChangeSuggestedNote?: (note: AlertLineSuggestedNoteRef) => void;
  latestSuggestedNote?: AlertLineSuggestedNoteRef;
}

interface State {
  suggestedNotes: AlertLineSuggestedNoteRef[];
  others: AlertLineSuggestedNoteRef[];
  loading: boolean;
  error: string;
  page: Page;
  open: boolean;
}

const AlertLineSuggestedNotes = ({
  alertLineURL,
  reportLanguage,
  handleChangeSuggestedNote,
  latestSuggestedNote,
}: Props) => {
  const theme = useTheme();

  const [state, setState] = useState<State>({
    suggestedNotes: [],
    others: [],
    loading: false,
    error: "",
    page: {
      pageSize: 100,
      pageNumber: 0,
    },
    open: false,
  });

  //#region load suggested notes
  const loadSuggestedNotes = useCallback(async () => {
    try {
      const response = await new AlertLineOrderedSuggestedNotesApiService().loadItems(
        {
          comesAfterNoteId: latestSuggestedNote?.id,
          alertLineURLId: alertLineURL?.id,
          languageId: reportLanguage?.id,
        } as AlertLineOrderedSuggestedNotesFilter,
        undefined,
        undefined,
        state.page,
        undefined,
        60,
        undefined
      );

      if (!response.error) {
        setState((state) => ({
          ...state,
          error: "",
          suggestedNotes: response.items[0].suggestedNotes,
          others: response.items[0].others,
        }));
      } else {
        setState((state) => ({
          ...state,
          error: response.error,
        }));
      }
    } catch (error) {
      setState((state) => ({
        ...state,
        error: error as string,
      }));
    } finally {
      setState((state) => ({ ...state, loadingSuggestedNotes: false }));
    }
  }, [latestSuggestedNote, state.page, alertLineURL, reportLanguage]);
  //#endregion

  useEffect(() => {
    if (state.open) loadSuggestedNotes();
  }, [state.page, latestSuggestedNote, state.open]);

  return (
    <>
      <IconButton
        onClick={() => setState((state) => ({ ...state, open: true }))}
        style={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        <FontAwesomeIcon icon={faQuoteLeft} />
      </IconButton>
      <Dialog
        open={state.open}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          title="Suggested notes"
          handleClose={() => setState((state) => ({ ...state, open: false }))}
        />
        <DialogContent>
          <Grid style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Divider>
              <Chip
                label="Suggested notes"
                style={{ color: theme.palette.secondary.light }}
              />
            </Divider>
            {state.suggestedNotes.length > 0 ? (
              state.suggestedNotes.map((suggesteddNote, idx) => (
                <Button
                  variant="outlined"
                  key={idx}
                  onClick={() => {
                    setState((state) => ({ ...state, open: false }));
                    handleChangeSuggestedNote && handleChangeSuggestedNote(suggesteddNote);
                  }}
                  style={{ textTransform: "none" }}
                >
                  {suggesteddNote.note}
                </Button>
              ))
            ) : (
              <Typography
                variant="body2"
                style={{ color: theme.palette.secondary.light }}
              >
                No suggested notes{" "}
              </Typography>
            )}

            {state.others.length > 0 && (
              <>
                <Divider>
                  <Chip
                    label="Others"
                    style={{ color: theme.palette.secondary.light }}
                  />
                </Divider>
                {state.others.map((suggesteddNote, idx) => (
                  <Button
                    variant="outlined"
                    key={idx}
                    onClick={() => {
                      setState((state) => ({ ...state, open: false }));
                      handleChangeSuggestedNote && handleChangeSuggestedNote(suggesteddNote);
                    }}
                    style={{ textTransform: "none", justifyContent: "flex-start" }}
                  >
                    {suggesteddNote.note}
                  </Button>
                ))}
              </>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default AlertLineSuggestedNotes;
